import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { IconButton, Tooltip } from '@mui/material';
import { parseAsBoolean, useQueryState } from 'nuqs';
import { useIntl } from 'react-intl';

/**
 * Toggle that switches between fullscreen and normal view using the fullscreen query param.
 * Always visible: enter fullscreen (hides sidenav) or exit fullscreen (shows sidenav).
 * URL state is managed via nuqs.
 */
export function FullscreenViewToggle() {
  const { $t } = useIntl();
  const [isFullscreen, setFullscreen] = useQueryState(
    'fullscreen',
    parseAsBoolean.withOptions({ history: 'replace' }),
  );

  const handleToggle = () => {
    setFullscreen(isFullscreen ? null : true);
  };

  const exitLabel = $t({
    id: 'logger.statusScreen.exitFullscreen',
    defaultMessage: 'Salir de pantalla completa',
  });

  const enterLabel = $t({
    id: 'logger.statusScreen.enterFullscreen',
    defaultMessage: 'Pantalla completa',
  });

  const label = isFullscreen ? exitLabel : enterLabel;

  return (
    <Tooltip title={label}>
      <IconButton onClick={handleToggle} aria-label={label}>
        {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </IconButton>
    </Tooltip>
  );
}
